import type { Variants } from 'framer-motion';

// Fade in animation
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } },
};

// Fade in up animation
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

// Fade in down animation
export const fadeInDown: Variants = {
  hidden: { opacity: 0, y: -20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

// Fade in left animation
export const fadeInLeft: Variants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

// Fade in right animation
export const fadeInRight: Variants = {
  hidden: { opacity: 0, x: 20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

// Scale in animation
export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
};

// Container animations with staggered children
export const containerAnimation: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3,
    },
  },
};

// Button hover animation
export const buttonHover = {
  scale: 1.05,
  transition: { duration: 0.2 },
};

// For services card hover
export const serviceCardHover = {
  y: -10,
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
  transition: { duration: 0.3 },
};

// Section animations based on scroll
export const scrollAnimation: Variants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  },
};

// Staggered card animations
export const staggerCards: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

// Card item animation
export const cardItem: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  },
};

// Heartbeat animation for special elements
export const heartbeat: Variants = {
  hidden: { scale: 1 },
  visible: {
    scale: [1, 1.03, 1],
    transition: {
      repeat: Number.POSITIVE_INFINITY,
      repeatType: 'reverse',
      duration: 1.5,
    }
  },
};

// Mobile menu animation
export const mobileMenuAnimation: Variants = {
  closed: {
    opacity: 0,
    x: '100%',
    transition: { duration: 0.3 }
  },
  open: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.3 }
  },
};
